<template>
    <div class="d-flex">
        <div class="login-bg"></div>
        <div class="login-container">
            <div class="login-container__wrapper">
                <a href="https://ivanhoe.io/" title="Go back to Ivanhoe.io">
                    <img
                        class="login-container__logo"
                        src="https://ivanhoe.io/assets/images/logo/ivanhoe.io-logo.svg"
                        alt="ivanhoe.io Logo"
                    />
                </a>
                <h1 class="login-container__title">
                    Request Reset Password
                </h1>
                <p v-if="errors.length">
                    <b class="text-danger" v-for="error in errors">{{ error }}</b>
                </p>
                <d-form v-if="! isSendRequest" class="login-form" @submit.prevent="handle">
                    <label for="newPassword" class="mb-1 d-block login-form__label">
                        New Password
                    </label>
                    <input
                        id="newPassword"
                        required
                        type="password"
                        placeholder="New Password"
                        v-model="password"
                        class="form-control d-block w-100 login-input"
                    />
                    <div class="d-flex d-md-block justify-content-between align-items-center mt-2">
                        <input value="Reset Password" type="submit" class="btn btn--primary d-md-block w-md-100">
                    </div>
                </d-form>
                <div v-else>
                    <p class="alert alert-success">Please, <router-link :to="{name: 'login'}">log in</router-link> with your new credentials!</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { AuthService } from '@/main'
    import GetParameter from 'get-parameter'

    export default {
        data() {
            return {
                password: null,
                isSendRequest: false,
                errors: []
            };
        },
        methods: {
            async handle() {
                try {
                    let token = GetParameter('code')
                    await AuthService.resetPasswordReset(token, this.password)
                    this.isSendRequest = true
                } catch(e) {
                    this.errors = [];
                    this.errors.push(e.networkError.result.errors[0].message);
                }
            }
        }
    };
</script>
